import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const RecommendedProduct = () => {
    const navigate = useNavigate();
    const loginId = localStorage.getItem('loginId');
    const [productDetail, setProductDetail] = useState([]);
    const [banner, setBanner] = useState([]);
    const [loading, setLoading] = useState(false);

    const GetProductDetail = useCallback(async () => {
        try {
            setLoading(true);
            const response = await get(API_URL.GetProductDetailByLoginId + `?pLoginId=${loginId || 0}`);
            if (response.isSuccess === 200) {

                const favoriteProducts = response?.data.filter(product => product.isFav === true);

                setProductDetail(favoriteProducts);
            } else {
                setProductDetail([]);
            }
        } catch (error) {
            setProductDetail([]);
        } finally {
            setLoading(false);
        }
    }, [loginId]);

    const GetBannerByBannerType = async () => {
        try {
            setLoading(true);
            const response = await get(API_URL.GetBannerByBannerType + `?pBannerTypeName=UnfoldtheBeauty`);
            if (response.isSuccess === 1) {
                setBanner(response?.data[0]);
            } else {
                setBanner([]);
            }
        } catch (error) {
            setBanner([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetProductDetail();
    }, [GetProductDetail]);

    useEffect(() => {
        GetBannerByBannerType();
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    };

    const onProductDetail = (item) => {
        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');
        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
        }

        localStorage.setItem('productId', item?.productId);

        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
    }

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <>
            {productDetail?.length > 0 && (
                <section>
                    <div className="hedding">
                        <h2>Recommended for You</h2>
                    </div>
                    <div className="container">
                        <div className="mt-5 recommended_wepper">
                            <div id="recommended" className="owl-carousel owl-theme">
                                <Slider {...settings}>
                                    {productDetail?.length > 0 &&
                                        productDetail.map((item, index) => {

                                            const headerImage = item.productImageDtos?.find(image => image.isHeader === true);
                                            const imagePath = headerImage
                                                ? `${imageUrl}${headerImage.imgPath}`
                                                : item?.productSkuDtos?.[0]?.productImageDtos?.length > 0
                                                    ? `${imageUrl}${item.productSkuDtos[0].productImageDtos[0].imgPath}`
                                                    : item?.productImageDtos?.length > 0
                                                        ? `${imageUrl}${item.productImageDtos[0].imgPath}`
                                                        : './images/defaultImage.png';

                                            return (
                                                <div className="item" key={index}>
                                                    <div className="recommended_inner cursor-pointer" onClick={() => onProductDetail(item)}>
                                                        <img className="recommended_big_img" src={imagePath} alt="" />
                                                        <div className="recommended_small_img">
                                                            <img src={imagePath} alt="" />
                                                            <p className="underline-hover mt-lg-auto mt-3">{item?.displayName}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
            )}
            <section className="bg_wepper">
                <div className="bg_banner_wepper desktop_banner">
                    <Link to={banner?.bannerUrl || '/'}>
                        <img src={`${imageUrl}${banner?.bannerImagePath}`} alt="" className="w-100" />
                    </Link>
                </div>
                <div className="bg_banner_wepper mobile_banner">
                    <Link to={banner?.bannerUrl || '/'}>
                        <img src={`${imageUrl}${banner?.bannerImageMobile}`} alt="" className="w-100" />
                    </Link>
                </div>
            </section>
        </>
    )
}

export default RecommendedProduct;